import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MainMenu.css";

function MainMenu() {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    const menuItems = [
        {
            name: "Home",
            path: "/",
            icon: "fa-home"
        },
        {
            name: "History",
            path: "History",
            icon: "fa-history"
        },
        {
            name: "Darshan Time",
            path: "Timing",
            icon: "fa-clock-o"
        },
        {
            name: "Accommodation",
            path: "Accommodation",
            icon: "fa-building"
        },
        {
            name: "Administration",
            path: "Administration",
            icon: "fa-users"
        },
        {
            name: "Tenders",
            path: "NewsEvents",
            icon: "fa-file-text"
        },
        {
            name: "Gallery",
            path: "Gallery",
            icon: "fa-image"
        },
        {
            name: "Contact",
            path: "Contact",
            icon: "fa-map-marker"
        }
    ];

    return (
        <>
            {/* =====================================
                FLOATING MENU BUTTON
            ====================================== */}

            <button
                className={`floating-menu-button ${
                    menuOpen ? "menu-button-open" : ""
                }`}
                onClick={toggleMenu}
                aria-label="Open menu"
            >
                <span className="menu-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>

                <span className="menu-button-text">
                    {menuOpen ? "Close" : "Menu"}
                </span>
            </button>


            {/* =====================================
                FULL SCREEN MENU
            ====================================== */}

            <div 
                className={`fullscreen-menu ${
                    menuOpen ? "fullscreen-menu-open" : ""
                }`} 
            >

                {/* Background Decoration */}

                <div className="menu-decoration decoration-one"></div>
                <div className="menu-decoration decoration-two"></div>


                {/* =================================
                    MENU HEADER
                ================================== */}

                <div className="fullscreen-menu-header">

                    <div className="temple-title" >

                        <div className="temple-symbol" >
                            {/* <i className="fa fa-temple"></i> */}
                             <img src="./images/image.png" alt="logo"  style={{width:'100%'}} />
                        </div>

                        <div>
                            <div className="temple-name" >
                                Sree Padmanabhaswamy Temple
                            </div>

                            <div className="temple-subtitle">
                                Thiruvananthapuram
                            </div>
                        </div>

                    </div>

                    <div className="menu-heading">
                        MENU
                    </div>

                </div>


                {/* =================================
                    MENU CONTENT
                ================================== */}

                <div className="fullscreen-menu-content">

                    <div className="menu-introduction">
                        <img src="./images/image.png" alt="logo"  style={{width:'100%'}} />

                        {/* <span className="menu-small-title">
                            Explore
                        </span> */}

                        {/* <h1>
                            Temple
                            <br />
                            <span>Navigation</span>
                        </h1> */}
{/* 
                        <div className="menu-line"></div> */}

                        {/* <p>
                            Discover the history, traditions, services
                            and facilities of Sree Padmanabhaswamy Temple.
                        </p> */}

                    </div>


                    {/* MENU ITEMS */}

                    <div className="menu-grid">

                        {menuItems.map((item, index) => (

                            <Link
                                key={item.name}
                                to={item.path}
                                className="fullscreen-menu-item"
                                onClick={closeMenu}
                                style={{
                                    "--item-index": index
                                }}
                            >

                                {/* <span className="menu-item-number">
                                    0{index + 1}
                                </span> */}

                                <span className="menu-item-icon">
                                    <i className={`fa ${item.icon}`}></i>
                                </span>

                                <span className="menu-item-name">
                                    {item.name}
                                </span>

                                <span className="menu-item-arrow">
                                    <i className="fa fa-arrow-right"></i>
                                </span>

                            </Link>

                        ))}


                        {/* ONLINE BOOKING */}

                        <a
                            href="https://booking.sreepadmanabhaswamytemple.org/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="fullscreen-menu-item booking-menu-item"
                            onClick={() => setMenuOpen(false)}
                        >

                            {/* <span className="menu-item-number">
                                09
                            </span> */}

                            <span className="menu-item-icon">
                                <i className="fa fa-globe"></i>
                            </span>

                            <span className="menu-item-name">
                                Online Booking
                            </span>

                            <span className="menu-item-arrow">
                                <i className="fa fa-external-link"></i>
                            </span>

                        </a>

                    </div>

                </div>


                {/* =================================
                    FOOTER
                ================================== */}

                {/* <div className="fullscreen-menu-footer">

                    <span>
                        Sree Padmanabhaswamy Temple
                    </span>

                    <span className="footer-divider">
                        |
                    </span>

                    <span>
                        Thiruvananthapuram, Kerala
                    </span>

                </div> */}

            </div>
        </>
    );
}

export default MainMenu;